import React from "react";
import Pro from "../../../../components/common/Tags/Pro";
import Pf from "../../../../assets/img/User.png";
import { Link } from "react-router-dom";
import {
  AdminMainText,
  AdminMetadataText,
  AdminFormSecondaryAction,
} from "../../../AdminDashboard/shared/adminUx";

const FollowingLayout = () => {
  const data = [
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: false, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: false },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: false, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: false },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: false, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: false },
    { profile: Pf, tag: true, company: "Maya's services", location: "Duffy, ACT, 2002", link: "/poster-profile", follow: true },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center justify-center 2xl:w-[912px] mx-auto">
      {data.map((e, index) => (
        <div
          key={index}
          className="bg-white lg:bg-pastalblue lg:w-[440px] lg:h-[230px] rounded-xl p-5 aspect-[440/230]"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="relative size-12">
                <img
                  className="object-center rounded-full size-12 cursor-pointer"
                  src={e.profile}
                  alt="no-profile"
                />
                {e.tag && (
                  <div className="absolute -mt-3 left-[30%] mr-2">
                    <Pro className="bg-primaryblue text-white" />
                  </div>
                )}
              </div>
              <div className="ml-3">
                <Link to={e.link}>
                  <AdminMainText className="text-offblack hover:text-primaryblue">
                    {e.company}
                  </AdminMainText>
                </Link>
                <AdminMetadataText className="mt-1 text-mediumgray block">
                  {e.location}
                </AdminMetadataText>
              </div>
            </div>
            <AdminFormSecondaryAction type="button" className="!w-auto !min-w-0">
              {e.follow ? "Unfollow" : "Follow"}
            </AdminFormSecondaryAction>
          </div>
          <div className="flex items-center space-x-4 lg:space-x-0 lg:justify-between sticky top-[100vh]">
            {[0, 1, 2].map((i) => (
              <div key={i} className="lg:w-[120px] lg:h-[90px] aspect-[120/90]">
                <img
                  src={require("../../../../assets/img/default-image.jpg")}
                  className="w-full h-full rounded-xl object-center"
                  alt="portfolio"
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FollowingLayout;
